<div class="wrapper" [class.fullscreen]="fullScreen">
  <div class="modal-content">
    <div class="modal-backdrop" (click)="onBackdropClick()"></div>

    <ng-container #viewContainer></ng-container>
  </div>
</div>
